// import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Col, Row } from "reactstrap";
import './style-modal.scss';

function MineMessage(props) {
    // const [message, setMessage] = useState('')

    // useEffect(() => {
    //     console.log("Effect running when item changed");
    // }, [message])

    return (
        <>
            {(props.message) ?
                <Row className={props.className || ''}>
                    <Col>
                        <Form.Text muted>
                            <div className={`info`} style={{ display: 'inline-flex' }}>
                                <div className="text-left" style={{ paddingRight: '0.625rem' }} >
                                    <i className="fa fa-info-circle" aria-hidden="true"></i>
                                </div>
                                <div className="text-left">
                                    {props.message}
                                </div>
                            </div>
                        </Form.Text>
                    </Col>
                </Row>:null
            }
        </>
    );
}

export default MineMessage;